import { PayMCopyDateModeAddExtended } from '../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderTable/TableComponents/ModalsOrderTable/ModalOrderPaymentMethod/types'

export const parsePaymentMethodDatesCopy = (paymentCopyDates: PayMCopyDateModeAddExtended[]) => {
    const copyDates = JSON.parse(JSON.stringify(paymentCopyDates))
    for (const element of copyDates) {
        element.date = new Date(element.date).toLocaleDateString()
        element.quantity= parseFloat(String(element.quantity))
        element.new_extra_payment_data = element.PayTCopy.new_extra_payment_data?.id || ''
    }
    return copyDates
}